import { useCallback } from "react";
import type { TodoFile } from "../../../../../../utils/backend-types";
import { uploadFileOrFiles } from "../../../../../../utils/files/uploadFileOrFiles";

interface UseUploadVollmachtUrls {
  uploadUrl: (siteId: number) => string;
}

function useUploadVollmacht<TResponse = TodoFile>(
  siteId: number,
  vollmachtUrls: UseUploadVollmachtUrls
) {
  const uploadVollmacht = useCallback(
    (files: File[], extraData?: Record<string, unknown>) => {
      const uploadPromises = files.map((file) =>
        uploadFileOrFiles<TResponse>(
          file,
          vollmachtUrls.uploadUrl(siteId),
          "data_file",
          { site: siteId, ...extraData },
          undefined,
          true
        )
      );

      return Promise.all(uploadPromises);
    },
    [siteId, vollmachtUrls]
  );

  return { uploadVollmacht };
}

export { useUploadVollmacht };
